module.exports = __webpack_public_path__ + "images/gadget/bg_fallback.png";